import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./MyAccountBox.module.css";
import environment from "../../../src/environment";
import { AccountContainer } from "../../hooks/useAccount";

const MyAccountBox = () => {
  const isDEV = environment.localDevMode;
  const navigate = useNavigate();
  const { logout } = AccountContainer.useContainer();
  

  const handleLogout = async () => {
    // document.cookie =
    //   "bidpro-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;" +
    //   (isDEV ? "" : " domain=.bidpro.com");

    await logout();
    window.location.href = "/pricing/ups";
  };

  const handleDashboard = () => {
    navigate("/account");
  };

  const handleProfile = () => {
    navigate("/account/update-profile", { state: { step: "updateProfile" } });
  };

  return (
    <div className={styles.myAccountContainer}>
      <button className={styles.accountButton}>MY ACCOUNT</button>
      <div className={styles.dropdownMenu}>
        <div className={styles.item} onClick={handleDashboard}>
          View Subscription Info
        </div>
        <div className={styles.item} onClick={handleProfile}>
          Update Profile
        </div>
        <div className={styles.item} onClick={handleProfile}>
          Change Password
        </div>
        <div className={styles.item} onClick={handleLogout}>
          Log Out
        </div>
      </div>
    </div>
  );
};

export default MyAccountBox;
